import React from "react";

//IMPORTANT:
// change the "fill" in the svg file to match the color of the icon
// fill="var(--icon-color, currentColor)"

interface CustomIconProps {
  IconComponent: React.ComponentType<{
    width?: string;
    height?: string;
    [key: string]: unknown;
  }>;
  width?: string;
  height?: string;
  color?: string;
  [key: string]: unknown;
}

const CustomIcon = ({
  IconComponent,
  width,
  height,
  color,
  ...props
}: CustomIconProps) => {
  return (
    <div
      style={{ "--icon-color": color || "currentColor" } as React.CSSProperties}
    >
      <IconComponent
        width={width || "24px"}
        height={height || "24px"}
        {...props}
      />
    </div>
  );
};

export default CustomIcon;
